import theme from "theme";
import { colors } from "theme/palette";

import Box from "components/Box";
import Stack from "components/Stack";
import Text from "components/Text";

export interface IContentSeparator {
  label: React.ReactNode;
  isFocused?: boolean;
  alignActionButton?: "left" | "right";
  actionButton?: React.ReactNode | undefined;
  dataTestid?: string;
}

const ContentSeparator = ({
  label,
  alignActionButton = "left",
  actionButton = undefined,
  dataTestid = "section-name",
  isFocused = false,
}: IContentSeparator) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent={
        alignActionButton === "left" ? "flex-start" : "space-between"
      }
      sx={{
        transition: "background-color 0.5s linear",
        backgroundColor: isFocused ? colors.green10 : colors.blue10,
        padding: theme.spacing(0.5, 1),
        breakInside: "avoid",
      }}
    >
      <Text
        variant="text1"
        sx={{ fontWeight: "bold", display: "inline" }}
        data-testid={dataTestid}
      >
        {label}
      </Text>
      {actionButton && <Box sx={{ display: "inline" }}>{actionButton}</Box>}
    </Stack>
  );
};

export default ContentSeparator;
